module.exports = __webpack_public_path__ + "img/creditcards.c638b2f.svg";